<template>
  <span
    ref="trigger"
    class="ca-servik-tooltip-trigger"
    @mouseenter="open"
    @mouseleave="close"
    @focus="open"
    @blur="close"
  >
    <slot />
  </span>
</template>

<script>
const TIP_CLASS = 'ca-servik-floating-tip'

export default {
  props: {
    /** i18n key for the servik name */
    label: { type: String, required: true },
  },
  beforeDestroy() {
    this.close()
  },
  methods: {
    open() {
      if (!this.$refs.trigger) return
      this.close()

      const rect = this.$refs.trigger.getBoundingClientRect()
      const tipEl = document.createElement('div')
      tipEl.className = TIP_CLASS
      tipEl.setAttribute('role', 'tooltip')
      tipEl.textContent = this.$t(this.label)
      document.body.appendChild(tipEl)

      const margin = 8
      const tipRect = tipEl.getBoundingClientRect()
      let top = rect.bottom + margin
      let left = rect.left + rect.width / 2 - tipRect.width / 2

      left = Math.max(margin, Math.min(left, window.innerWidth - tipRect.width - margin))

      if (top + tipRect.height > window.innerHeight - margin) {
        top = rect.top - tipRect.height - margin
      }
      if (top < margin) {
        top = margin
      }

      tipEl.style.top = `${Math.round(top)}px`
      tipEl.style.left = `${Math.round(left)}px`

      this._tipEl = tipEl
      this._onDismiss = () => this.close()
      window.addEventListener('scroll', this._onDismiss, true)
      window.addEventListener('resize', this._onDismiss)
    },
    close() {
      if (this._tipEl) {
        this._tipEl.remove()
        this._tipEl = null
      }
      if (this._onDismiss) {
        window.removeEventListener('scroll', this._onDismiss, true)
        window.removeEventListener('resize', this._onDismiss)
        this._onDismiss = null
      }
    },
  },
}
</script>

<style lang="scss">
.ca-servik-floating-tip {
  position: fixed;
  z-index: 10050;
  max-width: min(320px, calc(100vw - 16px));
  padding: 8px 10px;
  border-radius: 8px;
  background-color: #ecf0f1;
  color: #2c3e50;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  word-break: break-word;
}

.ca-servik-tooltip-trigger {
  display: inline-flex;
  vertical-align: middle;
}
</style>
